/** @format */

import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Chain, Environment } from '@shared/data-access/interfaces';
import { UtilityService, WINDOW } from '@shared/data-access/services';

@Component({
  selector: 'shared-components-affirm-pay-later',
  templateUrl: './affirm-pay-later.component.html',
  styleUrl: './affirm-pay-later.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AffirmPayLaterComponent implements OnInit, OnChanges {
  @Input() price: string;
  @Input() affirmPayLaterEnabled: boolean;
  @Input() page: string; // for supported values see https://docs.affirm.com/affirm-developers/docs/html-reference

  protected readonly window = inject(WINDOW);
  public readonly environment = inject(Environment);
  private readonly chain = inject(Chain);
  private readonly utilityService = inject(UtilityService);
  private readonly cdRef = inject(ChangeDetectorRef);

  ngOnInit() {
    if (this.affirmPayLaterEnabled) {
      this.enableAffirm();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.price) {
      if (changes.price.currentValue) {
        if (changes.price.currentValue.toString().indexOf('.') === -1) {
          this.price += '00';
        } else {
          const tempPrice = parseFloat(this.price) * 100;
          this.price = tempPrice.toString();
        }
      } else {
        this.price = '0';
      }

      // Update Affirm messaging after the first price update
      if (!changes.price.firstChange) {
        // Invoke changes so that we know affirm is being refreshed after the DOM
        this.cdRef.detectChanges();

        // Call affirm.ui.refresh to re-render the promotional messaging components
        if (typeof this.window.affirm?.ui?.refresh === 'function') {
          this.window.affirm.ui.refresh();
        }
      }
    }
  }

  private enableAffirm() {
    const { script } = this.environment.thirdParty.affirm.store[this.chain.chainIdentifierAbbr];
    if (script) {
      this.utilityService.loadExternalScript(script);
    }
  }
}
